window.$ = window.jQuery = require('jquery');
// window.slick = require('slick-carousel');
window.AOS = require('aos');
require('./header');
require('bootstrap');
$(window).on('load',function(){
  AOS.refresh();

});
$(function () {
  AOS.init({
    duration: 800,
    once: true
  });
  // アニメーションの設定


  smoothScroll();
  pageLoader();
  serviceImgTrim();
  setSlider();
  setFormPosition();
  indexServicesSlider();
  indexOtherSlider();
  navsHorizontalAlignment();
  newsTabsBtnLink();
  navsTabsChangeDesign();
  hoverDirectors();
  jumbotronSpImages();
  innnerHeightAlign();

  $(window).on('resize', function () {
    indexOtherSlider();
    navsHorizontalAlignment();
    navsTabsChangeDesign();
    jumbotronSpImages();
    innnerHeightAlign();

    // アニメーション再設定
    AOS.refresh();
  });

  $('.index-nav-tabs').scroll(function () {
    navsHorizontalTabDisabled();
  });
});

/*
    スムーススクロール
====================================*/
function smoothScroll() {
  $('a[href^="#"]:not([href^="#tab"]):not([href^="#close"])').click(function() {
    var href = $(this).attr('href');
    var target = $(href == '#' || href == '' ? 'html' : href);

    var tab = $(this).attr('role');
    if (!tab) {
      var position = target.offset().top;
      $('html, body').animate({scrollTop: position}, 500, 'swing');
      return false;
    }
  });

  if (location.search !== '') {
    var searchString = location.search;
    searchString = searchString.replace(/.*=/gi, '');

    // ニュースの場合（年で絞り込んだ場合）
    var pathname = location.pathname;
    if (pathname.match(/news/)) {
      var position = $('main section:first-of-type').offset().top;
      $('html, body').animate({scrollTop: position}, 500, 'swing');
    }
  }

  if (location.hash !== "") {
    var position = $(location.hash).offset().top;
    var hashString = location.hash.substr(1);

    // タブがある場合
    if ($('.tab-content')[0]) {
      if (hashString == "news") hashString = "news-all";
      $('.nav-link[role="tab"], .tab-pane').removeClass('active');
      $('.nav-link[role="tab"][href^="#' + hashString + '"], .tab-pane#' + hashString).addClass('active');
    }

    // 知財戦略以外の場合、お問い合わせフォーム以外の場合はハッシュ削除
    if (hashString !== 'kozin-1' && hashString.indexOf('wpcf7') !== 0) {
      history.replaceState('', document.title, window.location.pathname);
    }
    $('html, body').animate({ scrollTop: position }, 1);
    return false;
  }
}

/*
    ローディングアニメーションの設定
====================================*/
function pageLoader() {
  // ローディングアニメーションの設定がある場合
  if ($(".loader-wrapper").length) {
    // loader-disabledクラスがあった場合
    if ( $(".loader-wrapper").hasClass("loader-disabled") ) {
      // ローディングアニメーションを終了する
      $(".loader-wrapper").addClass("loaded");
    } else {
      // ロード画像を0にする
      var loadStatus = 0;
      // ページ内の画像の個数を設定する
      var img_num = $('img').length;

      // ページ内の画像個数分回す
      $('img').each(function() {
        var src = $(this).attr('src');
        // 画像を読み込んだら loadStatus を増やす
        $("<img>").attr('src', src).on('load',function() {
          loadStatus++;
        });
      });

      var timer = setInterval(function() {
        // 100%まで画像を読み込んだら
        if ((loadStatus / img_num) * 100 == 100) {
          clearInterval(timer);
          // ローディングアニメーションを終了する
          if ( !$(".loader-wrapper").hasClass("loaded") ) {
            $(".loader-wrapper").addClass("loaded");
          }
        }
      }, 0.01);

      setTimeout(function() {
        if ( !$(".loader-wrapper").hasClass("loaded") ) {
          $(".loader-wrapper").addClass("loaded");
        }
      }, 2000);
    }
  }
}

/*
    カードスタイルの画像トリミング
    /services
====================================*/
function serviceImgTrim() {
  // IEの場合は全て
  if ($('body').hasClass('ie')) {
    $('.card-img-wrapper').each(function() {
      var src = $(this).find('.card-img').attr('src');
      $(this).css('background-image', 'url('+src+')');
    });
  } else {
    $('.card-img-trim').each(function() {
      var src = $(this).find('.card-img').attr('src');
      $(this).css('background-image', 'url('+src+')');
    });
  }
}

/*
    FVのスライダー
====================================*/
function setSlider() {
  if ($("#slider")[0]) {
    // スタイダーの背景画像の設定
    $('.slide-item').each(function() {
      var class_name = $(this).find('a').attr('class').replace(/ .*/, "");
      var image_url = $(this).find('a').attr('data-thumb');
      $('head').append('<style>.slide-item a.'+class_name+'::before { background-image: url(' + image_url + ') }</style>');
    });

    // jQueryで～の要素に～クラスが付与されたら発動する機能を作成してみた。
    // https://ebatetsu.com/javascript/2017/11/addclass
    // $.fn.addClass_org = $.fn.addClass; // addClassイベントを保存
    // $.fn.addClass = function() {
    //   this.trigger('AddedClass', arguments); // カスタムイベントを設置
    //   return $.fn.addClass_org.apply(this, arguments); // 本来のaddClassを返す
    // };

    // $.fn.addedClass = function(className, callback) {
    //   var
    //   _that = this,
    //   _callback = callback || function() {};

    //   this.on('AddedClass', function() {
    //     var _arguments = arguments;
    //     setTimeout(function() {
    //       if(
    //         _arguments[1] === className &&
    //         _that.hasClass(className)
    //       ){
    //         _callback();
    //       }
    //     }, 0);
    //   });
    // }

    var slider = "#slider"; // スライダー
    var thumbnailItem = "#thumbnail-list .thumbnail-item"; // サムネイル画像アイテム

    // サムネイル画像アイテムに data-index でindex番号を付与
    $(thumbnailItem).each(function() {
      var index = $(thumbnailItem).index(this);
      $(this).attr("data-index",index);
    });

    // スライダー初期化後、カレントのサムネイル画像にクラス「thumbnail-current」を付ける
    // 「slickスライダー作成」の前にこの記述は書いてください。
    $(slider).on('init',function(slick) {
      var index = $(".slide-item.slick-slide.slick-current").attr("data-slick-index");
      $(thumbnailItem+'[data-index="'+index+'"]').addClass("thumbnail-current");
    });

    // サムネイル画像アイテムをクリックしたときにスライダー切り替え
    $(thumbnailItem).on('click',function() {
      var index = $(this).attr("data-index");
      $(slider).slick("slickGoTo",index,false);
    });

    // サムネイル画像のカレントを切り替え
    $(slider).on('beforeChange',function(event,slick, currentSlide,nextSlide) {
      $(thumbnailItem).each(function() {
        $(this).removeClass("thumbnail-current");
      });
      $(thumbnailItem+'[data-index="'+nextSlide+'"]').addClass("thumbnail-current");
    });

    var flag = false;
    // ローディングが終了したらスライダーの初期設定を実行
    // $('.loader-wrapper').addedClass('loaded', function() {
    //   // 先にスケールのみクラス追加
    //   $('.slide-item:first-child').addClass('is-scaling');

    //   // 1秒後にスライダー設定、テキストアニメーションの実行
    //   setTimeout(function() {
    //     console.log('slider1');
    //     // slickスライダー初期化
    //     $(slider).slick({
    //       dots: false,
    //       autoplay: true,
    //       autoplaySpeed: 5000,
    //       arrows: true,
    //       prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" onclick="gtag(\'event\', \'click\', {\'event_category\' : \'Slide Arrow\', \'event_label\' : \'Prev\'});">Previous</button>',
    //       nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" onclick="gtag(\'event\', \'click\', {\'event_category\' : \'Slide Arrow\', \'event_label\' : \'Next\'});">Next</button>',
    //       lazyLoad: 'ondemand',
    //       fade: true,
    //       infinite: true,
    //       pauseOnFocus: false,
    //       pauseOnHover: false,
    //       responsive: [
    //         {
    //           breakpoint: 767,
    //           settings: {
    //             dots: true,
    //             arrows: false
    //           }
    //         }
    //       ]
    //     });
    //   },1000);

    //   // 2秒後にスライダー設定、テキストアニメーションの実行
    //   setTimeout(function() {
    //     flag = true;
    //     $('.slide-item:first-child').addClass('is-text-animation');
    //     AOS.refresh();
    //   },2000);
    // });

    // スライドが切り替わったらスケールとアニメーションのクラス追加
    // $('.slide-item').addedClass('slick-active', function() {
    //   if (flag) {
    //     var active_no = $('.slide-item.slick-active').index('.slide-item') + 1;
    //     $('.slide-item:nth-child('+active_no+')').addClass('is-scaling is-text-animation');
    //     // 切り替わって0.5秒後に前のスライドのクラスを削除
    //     setTimeout(function() {
    //       $('.slide-item:not(:nth-child('+active_no+'))').removeClass('is-scaling is-text-animation');
    //     },500);
    //   }
    // });

    // IEの場合はサムネイルの横幅を設定する
    if ($('body').hasClass('ie')) {
      var slide_num = $('.thumbnail-item').length;
      $('.thumbnail-item').css('width', 100 / slide_num + '%');
    }
  }
}

/*
    contactform7のスタイル追加
====================================*/
function setFormPosition() {
  if ($('.wpcf7-form')[0]) {
    $('.wpcf7-form textarea, .wpcf7-form .note').parents('td').prev().css({'vertical-align':'top', 'line-height':'30px'});

    // レスポンスエリアは基本非表示
    if ($('.wpcf7-response-output.wpcf7-display-none')[0]) {
      $('.form-response').addClass('d-none');
    }

    // バリデーションエラーの場合
    if ($('.wpcf7-not-valid-tip')[0]) {
      $('.wpcf7-not-valid-tip').prev().addClass('validation-error');

      if ($('.select-box .wpcf7-not-valid-tip')[0]) {
        $('.select-box').addClass('validation-error');
      } else {
        $('.select-box').removeClass('validation-error');
      }
    }

    if ($('form.wpcf7-form').hasClass('sent')) {
      if ($('.formComplete')[0]) {
        // サンキューページ表示
        $('.formInner').css('display', 'none');
        $('.formComplete').css('display', 'block');
      } else {
        // サンキューページへリダイレクト
        var url = location.href;
        // 静的ページへのリダイレクトじゃない場合
        if (!(url.match(/(secondsight|remoteaction|smartfield|medical|agriculture)/))) {
          url = url.replace(/#.*/g, '').replace(/$/g, '-thanks');
          location = url;
        }
      }
    } else {
      // お問い合わせフォームの場合はフェードイン
      $('section.contact-form').fadeIn();
    }
  } else if ($('section.contact-form')[0]) {
    $('section.contact-form').fadeIn();
  }
}

/*
    FVのサービスリストのスライダー
====================================*/
function indexServicesSlider() {
  if ($('#index-services')[0]) {
    $('#index-services .card-list').slick({
      dots: true,
      autoplay: true,
      autoplaySpeed: 1500,
      arrows: true,
      prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" onclick="gtag(\'event\', \'click\', {\'event_category\' : \'Searvice Slide Arrow\', \'event_label\' : \'Prev\'});">Previous</button>',
      nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" onclick="gtag(\'event\', \'click\', {\'event_category\' : \'Searvice Slide Arrow\', \'event_label\' : \'Next\'});">Next</button>',
      lazyLoad: 'ondemand',
      infinite: true,
      slidesToShow: 5,
      centerMode: true,
      centerPadding: '100px',
      responsive: [
        {
          breakpoint: 2000,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            centerPadding: '50px',
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            centerPadding: '50px',
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            centerPadding: '50px',
          }
        }
      ],
    });
  }
}

/*
    FVのトピックとピックアップのスライダー
====================================*/
function indexOtherSlider() {
  if ($('#index-topics')[0]) {
    var bp = Number(getBreakpoint());
    if (bp < 1200) {
      if (!$('#index-topics .card-list').hasClass('slick-initialized')) {
        $('#index-topics .card-list').slick({
          dots: true,
          autoplay: true,
          autoplaySpeed: 1500,
          arrows: true,
          prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" onclick="gtag(\'event\', \'click\', {\'event_category\' : \'Topics Slide Arrow\', \'event_label\' : \'Prev\'});">Previous</button>',
          nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" onclick="gtag(\'event\', \'click\', {\'event_category\' : \'Topics Slide Arrow\', \'event_label\' : \'Next\'});">Next</button>',
          lazyLoad: 'ondemand',
          infinite: true,
          slidesToShow: 3,
          centerMode: true,
          centerPadding: '100px',
          responsive: [
            {
              breakpoint: 992,
              settings: {
                centerPadding: '50px',
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                centerPadding: '50px',
              }
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
                centerPadding: '50px',
              }
            }
          ],
        });
      }
    } else {
      setTimeout(function() {
        $('#index-topics .card-list.slick-initialized').slick('unslick');
      }, 100);
    }
    if (bp < 768) {
      if (!$('#index-pickup .card-list').hasClass('slick-slider')) {
        $('#index-pickup .card-list').slick({
          dots: true,
          autoplay: true,
          autoplaySpeed: 1500,
          arrows: true,
          prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" onclick="gtag(\'event\', \'click\', {\'event_category\' : \'Pick Up Slide Arrow\', \'event_label\' : \'Prev\'});">Previous</button>',
          nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" onclick="gtag(\'event\', \'click\', {\'event_category\' : \'Pick Up Slide Arrow\', \'event_label\' : \'Next\'});">Next</button>',
          lazyLoad: 'ondemand',
          infinite: true,
          slidesToShow: 2,
          centerMode: true,
          centerPadding: '50px',
          responsive: [
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
              }
            }
          ],
        });
      }
    } else {
      setTimeout(function() {
        $('#index-pickup .card-list.slick-initialized').slick('unslick');
      }, 100);
    }
  }
}

/*
    ニュースSP時の挙動
====================================*/
function navsHorizontalAlignment() {
  var bp = Number(getBreakpoint());
  if (bp < 768) {
    navsHorizontalTabDisabled();

    // 閲覧中ページのメニューを画面内で見えるようにする
    if ($('.jumbotron + nav .nav-link.active')[0]) {
      var parent_class = $('.jumbotron + nav ul').attr('class').replace(/.* /, '');
      target = $('.' + parent_class + ' .nav-link.active').offset().left - 30;
      if (target > 0) {
        $('.' + parent_class).animate({scrollLeft: target}, '1', function() {
          navsHorizontalTabDisabled(parent_class);
        });
      }
    }

    // 前へ、次へボタン クリック時
    $('.sidebar-nav').on('click', function() {
      // ページ全体からY座標の取得
      var thisY = $(this).offset().top;
      // スクロール量を取得
      var scroll = $(window).scrollTop();
      // 画面内の左端のスライダー位置にある要素を取得
      var element = document.elementFromPoint(30, thisY - scroll);
      // 要素内にli（a）タグが入っているかチェック
      var element_check = element.getElementsByTagName('a');
      // 1の場合：<li class="nav-item"><a class="nav-link">XXXXX</a></li>
      // 0の場合：<a class="nav-link">XXXXX</a>
      while (element_check.length == 0) {
        // 0の場合
        // <a class="nav-link">XXXXX</a>　を　<li class="nav-item"><a class="nav-link">XXXXX</a></li>　に修正
        element = element.parentElement;
        element_check = element.getElementsByTagName('a');
      }

      // 要素内にul（li）タグが入っているかチェック
      var element_check = element.getElementsByTagName('li');
      while (element_check.length != 0) {
        element = element.firstElementChild;
        element_check = element.getElementsByTagName('li');
      }

      var parent_class = $(this).prevAll('ul').attr('class').replace(/.* /, '');

      // リストの何番目か取得
      var n = $('.' + parent_class + ' .nav-item').index(element);

      if (n >= 0) {
        // ターゲットの初期化
        var target = 0;
        // 一番左の要素の座標取得
        var top = $('.nav-item:first-child').offset().left;

        // クリックした矢羽のクラス名の取得
        var class_name = $(this).attr('class');

        // 次へボタンクリックの場合
        if (class_name.match(/next/)) {
          n = n + 2;
          target = $('.nav-item:nth-of-type(' + n + ' )').offset().left;
          target = target - top;
        }
        // 戻るボタンクリックの場合
        else if (class_name.match(/prev/)) {
          if (n !== 0) {
            target = $('.nav-item:nth-of-type(' + n + ')').offset().left;
            target = target - top;
          } else {
            target = 0;
          }
        }
        $('.' + parent_class).animate({scrollLeft: target}, '500', function() {
          navsHorizontalTabDisabled(parent_class);
        });
      } else {
        navsHorizontalTabDisabled();
      }
    });
  }

  // タブクリック時
  $('.nav-link').on('click', function() {
    $('.tab-pane').find('.card-img-wrapper').removeAttr('data-aos');
  });
}

/*
    ニュースSP時のボタンdisabled
====================================*/
function navsHorizontalTabDisabled(parent_class) {
  if (parent_class) {
    var navFirst = 30;
    var navLast  = $(window).outerWidth() - 30;
    var navFirstPosition = Math.ceil($('.' + parent_class + ' .nav-item:first-child').offset().left);
    var navLastPosition  = Math.floor($('.' + parent_class + ' .nav-item:last-child').offset().left + $('.' + parent_class + ' .nav-item:last-child').outerWidth());

    if (navFirst <= navFirstPosition) {
      $('.' + parent_class + ' ~ .sidebar-nav.prev').prop('disabled', true);
    } else {
      $('.' + parent_class + ' ~ .sidebar-nav.prev').prop('disabled', false);
    }
    if (navLast >= navLastPosition) {
      $('.' + parent_class + ' ~ .sidebar-nav.next').prop('disabled', true);
    } else {
      $('.' + parent_class + ' ~ .sidebar-nav.next').prop('disabled', false);
    }
  } else {
    $('.sidebar-nav.prev').prop('disabled', true);

    var navLast  = $(window).outerWidth() - 30;
    $('.index-nav-tabs, .nav-horizontal-alignment').each(function() {
      var parent_class = $(this).attr('class').replace(/.* /, '');
      var navLastPosition = Math.floor($('.' + parent_class + ' .nav-item:last-child').offset().left + $('.' + parent_class + ' .nav-item:last-child').outerWidth());
      if (navLast >= navLastPosition) {
        $('.' + parent_class + ' ~ .sidebar-nav.next').prop('disabled', true);
      }
    });
  }
}

/*
    タブ切り替え時のボタンURL修正
====================================*/
function newsTabsBtnLink() {
  if ($('.btn-news')[0]) {
    var url = '';
    $('.nav-link').on('click', function() {
      var text = $(this).text();

      if (text === 'ニュース一覧') {
        url = '/news';
      } else if (text === 'お知らせ') {
        url = '/news/info';
      } else if (text === 'プレスリリース') {
        url = '/news/pressrelease';
      } else if (text === 'IPインフォメーション') {
        url = '/news/intellectual-property';
      } else if (text === 'メディア') {
        url = '/news/media';
      } else if (text === '採用情報') {
        url = '/recruit/#news';
      } else if (text === 'IR情報' || text === 'すべて') {
        url = '/investors/irnews';
      }

      $('.btn-news a').attr('href', url);
    });
  }
}

/*
    タブのPC、SPのデザイン切り替え
====================================*/
var tabsFlg = false;
function navsTabsChangeDesign() {
  if ($('.nav-tabs:not(.index-nav-tabs)')[0]) {
    $('.nav-tabs').each(function() {
      var bp = Number(getBreakpoint());
      if (bp >= 768) {
        tabsFlg = false;
        $(this).removeClass('sp-style');
      }
      var that = this;
      setTimeout(function() {
        if (bp < 768) {
          tabsFlg = true;
          $(that).addClass('sp-style');
        } else {
          var navH = $('.nav-tabs').outerHeight();
          var itemH = $('.nav-tabs .nav-item:first-child').outerHeight();
          if (navH !== itemH || tabsFlg === true) {
            if (tabsFlg === false) {
              tabsFlg = true;
            }
            $(that).addClass('sp-style');
          }
        }
      }, 100);
    });
  }
}

/*
    ディレクターhover時の挙動
====================================*/
function hoverDirectors() {
  if ($('.directors')[0]) {
    $('.directors img').hover(function(){
      var kaku = "";
      var img = $(this).attr("src").split(/(?=\.[^.]+$)/);
      kaku = img[1];
      $(this).attr('src', $(this).attr('src').replace(kaku, '_on' + kaku));
    }, function(){
      var kaku = "";
      var img = $(this).attr("src").split(/(?=\.[^.]+$)/);
      kaku = img[1];
      $(this).attr('src', $(this).attr('src').replace('_on' + kaku,kaku));
    });
  }
}

/*
    Jumbotron SP時の画像変更
====================================*/
function jumbotronSpImages() {
  if ($('.jumbotron')[0]) {
    var bp = Number(getBreakpoint());
    if (bp < 768) {
      img_src = $('.jumbotron').attr('style');
      img_src = img_src.replace(/.*url\(./gi, '').replace(/('|").*/gi, '');
      img_src_sp = img_src.replace(/\./gi, '_sp.');
      img_src_sp = img_src_sp.replace(/_sp_sp\./gi, '_sp.');

      checkImage(img_src_sp, img_src);
    } else {
      img_src = $('.jumbotron').attr('style');
      img_src = img_src.replace(/.*url\(./gi, '').replace(/('|").*/gi, '');
      img_src_pc = img_src.replace(/_sp\./gi, '.');

      checkImage(img_src_pc, img_src);
    }
  }
}

function checkImage(new_url, old_url) {
  var img = new Image();
  img.onload = function() {
    $('.jumbotron').css('background-image', 'url("'+new_url+'")');
  }
  img.onerror = function(){
    $('.jumbotron').css('background-image', 'url("'+old_url+'")');
  }
  img.src = new_url;
}

/*
    layout-style-i の高さを揃える
====================================*/
function innnerHeightAlign() {
  if ($('.layout-style-i')[0]) {
    // 元のスタイルを削除
    $('.layout-style-i .inner').css('height', '');

    var bp = Number(getBreakpoint());
    if (bp >= 768) {
      // .layout-style-i の個数分回す
      $('.layout-style-i').each(function(i, box) {
        var maxHeight = 0;
        // inner の個数分回す
        $(box).find('.inner').each(function() {
          // もし、高さが高い場合は、maxサイズを更新
          if ($(this).height() > maxHeight) maxHeight = $(this).height();
        });
        // 最大値で高さを設定
        $(box).find('.inner').height(maxHeight);
      });
    }
  }
}

/*
    ブレークポイント取得
====================================*/
function getBreakpoint() {
  if (window.matchMedia('(min-width: 1200px)').matches) {
    return '1200';
  } else if (window.matchMedia('(min-width: 992px)').matches) {
    return '992';
  } else if (window.matchMedia('(min-width: 768px)').matches) {
    return '768';
  } else if (window.matchMedia('(min-width: 576px)').matches) {
    return '576';
  } else {
    return '575';
  }
}
